/** Id of the element that takes focus for a Select with this `id` and `searchable` mode. */
export const getSelectTriggerId = (id: string, searchable?: boolean | 'contextual' | 'portal'): string =>
    searchable === 'portal' ? `${id}-trigger` : searchable === 'contextual' ? id : `${id}-dropdownTrigger`;
